import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Lenis from '@studio-freight/lenis';

// Components - removed CustomCursor
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { GallerySection } from './components/GallerySection';
import { ReviewsSection } from './components/ReviewsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { QuoteModal } from './components/QuoteModal';

import './App.css';

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  // Initialize smooth scrolling
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  return (
    <div className="relative noise-overlay">
      {/* Header */}
      <Header onQuoteClick={openQuoteModal} />

      {/* Main content */}
      <main>
        <HeroSection onQuoteClick={openQuoteModal} />
        <AboutSection />
        <ServicesSection onQuoteClick={openQuoteModal} />
        <GallerySection />
        <ReviewsSection />
        <ContactSection onQuoteClick={openQuoteModal} />
      </main>

      {/* Footer */}
      <Footer />

      {/* Sticky Quote Button (Desktop) - RED */}
      <motion.button
        onClick={openQuoteModal}
        className="hidden lg:flex fixed right-0 top-1/2 -translate-y-1/2 z-40 bg-red-600 text-white font-black uppercase tracking-wider py-4 px-3 rounded-l-sm shadow-lg items-center gap-2"
        style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
        initial={{ x: 100 }}
        animate={{ x: 0 }}
        transition={{ delay: 1 }}
        whileHover={{ scale: 1.05, boxShadow: '0 0 25px rgba(220, 38, 38, 0.6)' }}
        whileTap={{ scale: 0.95 }}
        data-testid="sticky-quote-btn"
        aria-label="Get a free quote for sealcoating services"
      >
        Get Free Quote
      </motion.button>

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </div>
  );
}

export default App;
